module.exports = __webpack_public_path__ + "static/media/guanfang.168605a6.jpg";